export const CheckIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="shrink-0">
    <rect x="2" y="2" width="20" height="20" rx="6" fill="#146464" />
    <path d="M7.5 11.5L10.5 14.5L16.5 8.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const UncheckedIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="shrink-0">
    <rect x="2" y="2" width="20" height="20" rx="6" stroke="rgba(0,0,0,0.2)" strokeWidth="1" fill="none" />
  </svg>
);

export const CheckmarkSmall = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="shrink-0 text-success">
    <path d="M3 8L6.5 11.5L13 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PlayIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="ml-1">
    <path d="M8 5v14l11-7L8 5z" fill="#146464" />
  </svg>
);
